import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "./shared/shared.module";
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';

// for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';

// import { AuthService } from './shared/services/firebase/auth.service';
import { AdminGuard } from './shared/guard/admin.guard';
import { AuthGuard } from './shared/guard/auth.guard';
import { CookieService } from 'ngx-cookie-service';
import { AppComponent } from './app.component';
import { NotificationService } from './shared/services/notification.service';
import { PagingServerService } from './shared/services/paging-server-service';
import { MyPipesModule } from './shared/services/my-pipes';
import { ConfirmationDialogComponent } from "./shared/components/confirmation-dialog/confirmation-dialog.component";
import { ConfirmationDialogService } from "./shared/components/confirmation-dialog/confirmation-dialog.service";
import { HttpService } from './shared/services/http.service';
import { DataStorageService } from './shared/services/data-storage.service';
import { CommonService } from './shared/services/common-service.service';
import { HasRoleGuard } from './shared/services/has-role.guard';
import { IsAuthenticatedGuard } from './shared/services/is-authenticated.guard';
import { AuthService } from './shared/services/auth.service';
import { VehicleMasterService } from './shared/services/vehicle-master.service';
import { DriverMasterService } from './shared/services/driver-master.service';
import { CabBookingService } from './shared/services/cab-booking.service';
import { GuestHouseBookingService } from './shared/services/guest-house-booking.service';
import { HttpModule } from '@angular/http';
import { HomeComponent } from './components/home/home.component';
// import { JwtModule } from '@auth0/angular-jwt';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { ExcelExportService } from './shared/services/ExcelExportService';
import { JwtModule } from '@auth0/angular-jwt';
import { HttpInterceptorModule, HttpRequestInterceptor } from '../app/security/http-interceptor/http-interceptor.module';
import { TokenInterceptorService } from './token-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './components/Login/login/login.component';
import { NewReportComponent } from './components/Login/new-report/new-report.component';
import { LoginGuard } from './shared/guard/login.guard';
import { LoginAuthService } from './service/login-auth.service';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    //NewReportComponent,

    

  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
   // ToastrModule.forRoot(),
    // AngularFireModule.initializeApp(environment.firebase),
    // AngularFirestoreModule,
    // AngularFireAuthModule,
  
    // for HttpClient use:
    LoadingBarHttpClientModule,
    // for Router use:
    LoadingBarRouterModule,
    // for Core use:
    LoadingBarModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    MyPipesModule,
    NgSelectModule,
    NgOptionHighlightModule,

    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem("token");
        },
        allowedDomains: ["localhost:4200", "localhost:5001", "localhost:44393", "ams.rspl.net.in"],
        disallowedRoutes: ["http://example.com/examplebadroute/"],
      }
    }),
  ],
  entryComponents: [ ConfirmationDialogComponent ],
  providers: [ AdminGuard,AuthGuard, CookieService,PagingServerService,NotificationService,
    ConfirmationDialogService,HttpService,DataStorageService,CommonService,CabBookingService,HasRoleGuard,IsAuthenticatedGuard,
  AuthService,GuestHouseBookingService,VehicleMasterService,ExcelExportService,DriverMasterService,HttpInterceptorModule,
  ExcelExportService,LoginGuard,LoginAuthService,
  {
    provide:HTTP_INTERCEPTORS,
    useClass:TokenInterceptorService,
    multi:true
  },
],
  bootstrap: [AppComponent]
  
})
export class AppModule { }
